import _ from 'lodash'

import { MiniTable, Json } from 'peach/components'

const FancyLedgerTable = ({ ledger }) => {
  const columns = ['Entry', 'IDs', 'Data', 'Dates']

  const rows = _.map(ledger, (entry) => {
    const {
      id,
      bucketId,
      companyId,
      eventId,
      insertId,
      ledgerId,
      bucketName: rawBucketName,
      effectiveDate,
      entryIndex,
      eventName,
      ledgerType,
      pairIndex,
      postedDate,
      transactionType,
      value,
      createdAt,
    } = entry

    const bucketName = _.str.titleize(_.str.humanize(rawBucketName))

    const nameInfo = { bucketName, eventName, id }
    const ids = { companyId, eventId, bucketId, insertId, ledgerId }
    const data = { entryIndex, ledgerType, pairIndex, transactionType, value }
    const dates = { effectiveDate, postedDate, createdAt }

    return (
      <MiniTable.Row key={id}>
        <Json.List compact humanizeKeys json={nameInfo} />
        <Json.List compact humanizeKeys json={ids} />
        <Json.List compact humanizeKeys json={data} />
        <Json.List compact humanizeKeys json={dates} />
      </MiniTable.Row>
    )
  })

  return (
    <MiniTable columns={columns} compact fixed>
      {rows}
    </MiniTable>
  )
}

export default FancyLedgerTable
